var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdminSwitchBack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.3,37v143c0,6.6,5.4,12,12,12h143c10.7,0,16-12.9,8.5-20.5l-54.1-54.1C153.1,81.9,202.1,60,256.3,60 c104.5,0,189.8,81.6,195.7,184.7c0.4,6.3,5.6,11.3,12,11.3h28c6.8,0,12.3-5.7,12-12.5C497.5,112.3,389.1,8,256.3,8 C187.8,8,125.8,35.8,80.9,80.6L28.8,28.5C21.2,20.9,8.3,26.3,8.3,37z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminSwitchBack);
export default __webpack_public_path__ + "static/media/admin-switch-back.e0701e4fd2ff55a2be852bd62716bb44.svg";
export { ForwardRef as ReactComponent };